import { Typography } from '@mui/material';
import { parseReportDateToLocaleFormat } from '@utils/dates';

type SalesDataRefreshedProps = {
  reportDate: string;
};

export const SalesDataRefreshed = (props: SalesDataRefreshedProps) => (
  <Typography textAlign="right">
    Sales Data refreshed on {parseReportDateToLocaleFormat(props.reportDate)}
  </Typography>
);
